import { render, staticRenderFns } from "./EPointTransferDialog.vue?vue&type=template&id=518175a6&"
import script from "./EPointTransferDialog.vue?vue&type=script&lang=js&"
export * from "./EPointTransferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QInput,QChip,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QInput,QChip,QIcon,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
